export default __webpack_public_path__ + "static/media/gbp.320bf846.png";